// packages
import 'intersection-observer';
import yall from 'yall-js';
import Masonry from 'masonry-layout';

// local imports
import { AdLoader } from './ads/loader';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', yall);

// Write your code!
console.log('Hello, world!');

var grid = document.querySelector('.grid');
var msnry = new Masonry(grid, {
  itemSelector: '.grid-item',
  columnWidth: '.grid-sizer',
  gutter: 20,
});

const cards = document.getElementsByClassName('grid-item');

var clickedButtons = document.querySelector('.clicked');

function getfilterElements(button) {
  var filArray = [];
  filArray.push(allSelect.value);
  filArray.push(button.value);
  return filArray;
}

function getClicked(clickedElement) {
  for (let i = 0; i < allButtons.length; i++) {
    allButtons[i].classList.remove('clicked');
  }
  clickedElement.classList.add('clicked');
  clickedButtons = document.querySelector('.clicked');
}

const getFilters = function () {
  var isin = false;

  clickedButtons = document.querySelector('.clicked');

  var filters = getfilterElements(clickedButtons);

  console.log(filters);

  for (let index = 0; index < cards.length; index++) {
    cards[index].style.display = 'block';
    const filterString = cards[index].getAttribute('data-filter');
    for (let j = 0; j < filters.length; j++) {
      if (filters[j] == 'all') {
        isin = true;
      } else {
        isin = filterString.includes(filters[j]);
      }

      if (!isin) {
        cards[index].style.display = 'none';
      }
    }
    // if (!isin){
    //     cards[index].style.display = 'none';
    // }
  }
  msnry.layout();
};

const getButtons = function () {
  var isin = false;

  getClicked(this);

  var filters = getfilterElements(clickedButtons);

  console.log(filters);

  for (let index = 0; index < cards.length; index++) {
    cards[index].style.display = 'block';
    const filterString = cards[index].getAttribute('data-filter');
    for (let j = 0; j < filters.length; j++) {
      if (filters[j] == 'all') {
        isin = true;
      } else {
        isin = filterString.includes(filters[j]);
      }

      if (!isin) {
        cards[index].style.display = 'none';
      }
    }
    // if (!isin){
    //     cards[index].style.display = 'none';
    // }
  }
  msnry.layout();
};

let allSelect = document.querySelector('#work');
allSelect.addEventListener('change', getFilters);

let allButtons = document.querySelectorAll('button');

for (let i = 0; i < allButtons.length; i++) {
  allButtons[i].addEventListener('click', getButtons);
}
